<template>
  <teleport to="body">
    <div :class="fadeTransition" class="modal">
      <div :class="bounceTransition" class="modal-body">
        <div class="close-svg" @click="closeModal">
          <CloseSVG :propId="'print-close'" :fillColor="'#f7f9fc'" />
        </div>
        <h1 class="modal-header">
          <div>
            <font-awesome-icon icon="download" aria-hidden="true" /><span> PDF Downloaded</span>
          </div>
        </h1>
        <div class="modal-content">
          <div>
            <p><strong>Need to change your design?</strong></p>
            <p>You can edit and print your design as many times as you need.</p>
            <p @click="closeModal">Edit your design ›</p>
          </div>
          <div>
            <p><strong>Need help printing?</strong></p>
            <p>
              We can help you troubleshoot common label printing issues to get the perfect print!
            </p>
            <p @click="openPrintingHelp">Get help printing your labels ›</p>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script lang="ts">
import { defineComponent, Ref, inject } from "vue";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "PrintingCompleted",
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const openPrintingHelp = () => {
      store.dispatch(ActionTypes.SET_MODAL, "printingHelp");
    };

    return { closeModal, bounceTransition, fadeTransition, openPrintingHelp };
  },
});
</script>

<style scoped>
.modal-body {
  flex-direction: column;
  justify-content: space-between;
  padding: 3rem;
  width: 500px;
  height: 275px;
}

.modal-header {
  color: #00af43;
  font-size: 3rem;
}

.modal-content {
  display: flex;
  justify-content: space-between;
  font-size: 1.5rem;
}

.modal-content div {
  width: 200px;
}

.modal-content div:first-child {
  margin-right: 4rem;
}

.modal-content p {
  padding-top: 2rem;
}

.modal-content div p:last-child {
  color: #0096ff;
  cursor: pointer;
}

@media (max-width: 767px) {
  .modal-body {
    height: 35% !important;
  }

  .modal-content div:first-child {
    margin-right: 2rem !important;
  }
}

@media (max-width: 550px) {
  .modal-body {
    width: 90%;
  }

  .modal-header {
    font-size: 2rem;
    padding-bottom: 0;
  }

  .modal-header span {
    margin-right: 1rem;
  }

  .modal-content {
    flex-direction: column;
  }

  .modal-content div {
    width: auto;
    margin-top: 1rem;
  }

  .modal-content p {
    padding-top: 1rem;
  }

  .modal-content div:first-child {
    margin-right: 0;
  }

  .modal-content div:last-child {
    padding-top: 2rem;
  }
}
</style>
